//Class qui contient les fontions par défaut des scènes.

import { tags } from "../consts/Tags.js";
import { Colors } from "../consts/Colors.js";
import { Sizes } from "../consts/Sizes.js";

export default class AbstractScene extends Phaser.Scene {
  //Initialisation par défaut, à ajouter dans tous les initialisation
  //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
  _init(data) {
    console.log("Start :", this.scene.key, data);
    this.data = {};

    this.game.data.sceneRunning = this.scene.key;

    if (data) {
      // Data à faire passer au besoin
    }
  }

  //Preload de la scene par défaut, initialise les variables utiles
  _preload() {
    this.width = this.cameras.main.width; //Largeur de l'écran
    this.height = this.cameras.main.height; //Hauter de l'écran

    this.scaleX = 2.8;
    this.scaleY = 2;
    this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
    this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran

    this.preTarget = () => {
      console.warn("preTarget() n'est pas défini dans cette scène.");
    };

    this.postTarget = () => {
      console.warn("postTarget() n'est pas défini dans cette scène.");
    };

    if (this.sound && this.sound.stopAll) {
      this.sound.stopAll();
    }
  }

  update() {
    if (!this.video) return;
    if (!this.videoControlsActive) return;

    if (this.isPlaying && !this.isDraging) {
      this.currentTiming = this.video.getCurrentTime();
      this.totalDuration = this.video.getDuration();
      this.slider.value = this.currentTiming / this.totalDuration;
      const progress = this.video.getProgress();
      this.barFill.width = progress * this.barWidth;
    } else if (this.isDraging) {
      const progress = this.video.getProgress();
      const duration = this.video.getDuration();
      const current = progress * duration;
      if (this.currentTimeText) {
        this.currentTimeText.setText(this.formatTime(current));
      }
      this.barFill.width = this.slider.value * this.barWidth;
    }

    if (this.isPlaying) {
      const duration = this.video.getDuration();
      const progress = this.video.getProgress();
      const current = progress * duration;
      if (this.currentTimeText) {
        this.currentTimeText.setText(this.formatTime(current));
      }
      if (this.durationText) {
        this.durationText.setText(this.formatTime(duration));
      }
    }
  }

  nextScene() {
    var sceneInfo = this.game.data[this.game.data.sceneRunning];
    this.scene.start(sceneInfo.next, this.data);
  }

  clone(element) {
    var clone = Phaser.Utils.Objects.Clone(element);
    this.add.existing(clone);
    return clone;
  }
  addAnimatedArrows() {
    const arrows = [];
    const arrowPositions = [
      { x: 0, y: 50 },
      { x: 300, y: 20 },
      { x: -100, y: this.height - 250 },
      { x: this.width - 200, y: -70 },
      { x: this.width - 400, y: 0 },
    ];
    for (let i = 0; i < arrowPositions.length; i++) {
      const arrow = this.add.image(
        arrowPositions[i].x,
        arrowPositions[i].y,
        `arrow${i + 1}`
      );
      arrow.setOrigin(0, 0);
      arrow.setScale(0);
      arrow.setAlpha(0);
      arrows.push(arrow);
    }

    this.tweens.add({
      targets: arrows,
      alpha: 1,
      scale: 1,
      duration: 500,
      ease: "Sine.easeInOut",
      /* onComplete: () => {
        this.tweens.add({
          targets: arrows,
          x: (arrow) => arrow.x + 5,
          duration: 500,
          ease: "Sine.easeInOut",
          yoyo: true,
          repeat: -1,
        });
      }, */
    });
    /*  this.tweens.add({
      targets: arrows,
      y: (arrow) => arrow.y + 20,
      duration: 500,
      ease: "Sine.easeInOut",
      yoyo: true,
      repeat: -1,
    }); */
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  }
}
